import React from "react";
import "./Profile.css";
import UserProfile from "../profileComponent/userProfiles/UserProfile";
import MentorProfile from "../profileComponent/userProfiles/MentorProfile";
import ExpertProfile from "../profileComponent/userProfiles/ExpertProfile";
import { useAuth } from "../AuthContext";

function Profile() {
    const { userData } = useAuth();

    if (!userData) {
        return <div className="profile-container">No user data found. Please log in.</div>;
    }

    switch (userData.role) {
        case "users":
            return <UserProfile userData={userData} />;
        case "mentors":
            return <MentorProfile userData={userData} />;
        case "experts":
            return <ExpertProfile userData={userData} />;
        default:
            return <div className="profile-container">Invalid role</div>;
    }
}

export default Profile;
